const PartsNotFound = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-100 text-center">
      <h1 className="text-6xl font-extrabold text-[#0C1C3F]">
        Oops !!!
      </h1>

      <p className="mt-4 text-2xl font-semibold text-gray-800">
        404 : Parts Not Found
      </p>

      <p className="mt-2 max-w-md text-gray-600">
        The Page you are looking for doesn’t exist or may have been moved.
      </p>

      <a
        href="/"
        className="mt-6 rounded-xl bg-blue-600 px-6 py-3 text-sm font-semibold text-white hover:bg-blue-500"
      >
        Go back to Home
      </a>
    </div>
  );
};

export default PartsNotFound;
